import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetch_all_labs } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchLab = async (setLab, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetch_all_labs();
    
    if (response.statusText=="OK") {
      const data = response?.data;
      setLab(data.labs);
    } else {
      message.error("Failed to fetch lab.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching lab.");
  }
};
